// JSONToCSV.ts
import Papa from "papaparse";
import { mongoDBDateParserToUSAFormat_v2 } from "./dates";
import { formatDecimalNumber } from "./formatDecimalNumber";
import { handleChangeHeader } from "./fieldCapitalize";

const convertJSONToCSV = (jsonArray: any[], fileName: string) => {
	const csvData = jsonArray.map((item: any) => {
		delete item._id;
		const csvItem: { [key: string]: any } = {};
		delete item["_id"];
		Object.keys(item).forEach((key: any) => {
			let header = handleChangeHeader(key).replace("CHEQUE", "CHECK");
			if (
				key === "total_charge" ||
				key === "discount" ||
				key === "savings" ||
				key === "allowable" ||
				key === "TPA_fee" ||
				key === "net_savings" ||
				key === "copay" ||
				key === "paid" ||
				key === "other_fee"
			) {
				header += " ($)";
			}
			if (
				key === "date_of_service" ||
				key === "closure_ltr_date" ||
				key === "closure_sent_date" ||
				key === "cheque_mailed" ||
				key === "cheque_cleared" ||
				key === "cheque_received" ||
				key === "reissued" ||
				key === "open_negotiation_notice_end_of_right_to_initiate_on" ||
				key === "open_negotiation_notice_received_date" ||
				key === "open_negotiation_period_ending" ||
				key === "notice_of_idr_initiation_end_of_right_to_initiate" ||
				key === "notice_of_idr_initiation_received_date" ||
				key === "selection_of_certified_idr_entity" ||
				key === "final_selection_of_idr_entity" ||
				key === "submission_of_offer" ||
				key === "selection_of_offer_and_decision" ||
				key === "payment_of_oon_rate" ||
				key === "cooling_off_period" ||
				key === "updated_date" ||
				key === "first_appeal_received" ||
				key === "date_to_send_first_appeal_response" ||
				key === "first_appeal_response_date" ||
				key === "idr_decision_date" ||
				key === "open_negotiation_response_date" ||
				key === "updatedAt" ||
				key === "createdAt" ||
				key === "admin_fee_date"
			) {
				csvItem[header] = item[key] ? mongoDBDateParserToUSAFormat_v2(item[key]) : "N/A";
			} else if (
				key === "total_charge" ||
				key === "discount" ||
				key === "savings" ||
				key === "allowable" ||
				key === "TPA_fee" ||
				key === "net_savings" ||
				key === "percentage_savings"
			) {
				csvItem[header] = item[key] ? formatDecimalNumber(Number(item[key])) : "N/A";
			} else if (key === "reissued") {
				csvItem[header] = item[key] ? item[key] : "N/A";
			} else {
				csvItem[header] = item[key];
			}
		});
		return csvItem;
	});

	const csv = Papa.unparse(csvData);
	const csvBlob = new Blob([csv], { type: "text/csv" });
	const csvUrl = URL.createObjectURL(csvBlob);

	const link = document.createElement("a");
	link.href = csvUrl;
	link.download = fileName;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	URL.revokeObjectURL(csvUrl);
};

export default convertJSONToCSV;
